import React, { useEffect, useState } from 'react';
import { Card, CardBody, Button, Row, Col, Input, Spinner, Pagination, PaginationItem, PaginationLink, FormGroup, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import api, { FILE_BASE_URL } from '../../utils/api';

const InstitutionsCards = () => {
  const [institutions, setInstitutions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [country, setCountry] = useState('فلسطين');
  const [province, setProvince] = useState('');
  const [orientation, setOrientation] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    fetchInstitutions();
    fetchUserRole();
  }, [search, country, province, orientation, page]);

  const fetchInstitutions = async () => {
    setLoading(true);
    try {
      const response = await api.get('/institutions/cards', {
        params: {
          search,
          country,
          province,
          orientation,
          page
        }
      });
      setInstitutions(response.data.data || []);
      setTotalPages(response.data.last_page || 1);
    } catch (error) {
      setInstitutions([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserRole = async () => {
    try {
      const response = await api.get('/user');
      setUserRole(response.data.role || '');
    } catch {
      setUserRole('');
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleCountryChange = (selectedCountry) => {
    setCountry(selectedCountry);
    if (selectedCountry !== 'فلسطين') {
      setProvince('');
    }
    setPage(1);
  };

  const countries = [
    'فلسطين', 'الأردن', 'لبنان', 'سوريا', 'مصر', 'السعودية', 'الإمارات', 'قطر', 
    'الكويت', 'العراق', 'المغرب', 'الجزائر', 'تونس', 'ليبيا', 'السودان', 'اليمن', 'عمان', 'البحرين', 'أخرى'
  ];

  const provinces = ['اريحا', 'الخليل', 'القدس', 'بيت لحم', 'جنين', 'رام الله', 'سلفيت', 'طوباس', 'طولكرم', 'غزة', 'قلقيلية', 'نابلس'];
  
  const orientations = ['مؤيد', 'معارض', 'محايد'];

  return (
    <div>
      <div className="d-flex align-items-center mb-4">
        <div 
          className="d-flex align-items-center justify-content-center rounded-circle me-3"
          style={{
            width: '50px',
            height: '50px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white'
          }}
        >
          <i className="mdi mdi-office-building mdi-24px"></i>
        </div>
        <div>
          <h4 className="card-title mb-1">بطاقات المؤسسات</h4>
          <p className="text-muted mb-0">تصفح وابحث في المؤسسات المسجلة</p>
        </div>
      </div>
      
      {/* Search Form */}
      <div 
        className="p-4 rounded mb-4"
        style={{ 
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          border: '1px solid #e3ebf0'
        }}
      >
        <Row className="g-3 align-items-end">
          <Col lg="3" md="6">
            <div className="position-relative">
              <Label className="form-label fw-semibold text-dark">
                <i className="mdi mdi-account-search me-2 text-warning"></i>
                الاسم
              </Label>
              <Input
                type="text"
                placeholder="🔍 ابحث بالاسم..."
                value={search}
                onChange={handleSearch}
                className="form-control-lg border-0 shadow-sm"
                style={{ borderRadius: '12px' }}
              />
            </div>
          </Col>
          
          <Col lg="2" md="6">
            <div className="position-relative">
              <Label className="form-label fw-semibold text-dark">
                <i className="mdi mdi-earth me-2 text-info"></i>
                الدولة
              </Label>
              <Input
                type="select"
                value={country}
                onChange={(e) => handleCountryChange(e.target.value)}
                className="form-control-lg border-0 shadow-sm"
                style={{ 
                  borderRadius: '12px',
                  paddingRight: '3rem'
                }}
              >
                <option value="">جميع الدول</option>
                {countries.map(country => (
                  <option key={country} value={country}>{country}</option>
                ))}
              </Input>
            </div>
          </Col>

          {/* المحافظة - تظهر فقط إذا كانت الدولة فلسطين */}
          {country === 'فلسطين' && (
            <Col lg="2" md="6">
              <div className="position-relative">
                <Label className="form-label fw-semibold text-dark">
                  <i className="mdi mdi-map-marker me-2 text-success"></i>
                  المحافظة
                </Label>
                <Input
                  type="select"
                  value={province}
                  onChange={(e) => { setProvince(e.target.value); setPage(1); }}
                  className="form-control-lg border-0 shadow-sm"
                  style={{ 
                    borderRadius: '12px',
                    paddingRight: '3rem'
                  }}
                >
                  <option value="">جميع المحافظات</option>
                  {provinces.map(province => (
                    <option key={province} value={province}>{province}</option>
                  ))}
                </Input>
              </div>
            </Col>
          )}
          
          <Col lg="2" md="6">
            <div className="position-relative">
              <Label className="form-label fw-semibold text-dark">
                <i className="mdi mdi-compass me-2 text-primary"></i>
                التوجه
              </Label>
              <Input
                type="select"
                value={orientation}
                onChange={(e) => { setOrientation(e.target.value); setPage(1); }}
                className="form-control-lg border-0 shadow-sm"
                style={{ 
                  borderRadius: '12px',
                  paddingRight: '3rem'
                }}
              >
                <option value="">جميع التوجهات</option>
                {orientations.map(orient => (
                  <option key={orient} value={orient}>{orient}</option>
                ))}
              </Input>
            </div>
          </Col>
          
          <Col lg={country === 'فلسطين' ? "3" : "5"} md="4">
            <Label className="form-label">&nbsp;</Label>
            <div className="d-flex gap-2">
              <Button 
                color="light" 
                onClick={() => {
                  setSearch('');
                  setCountry('فلسطين');
                  setProvince('');
                  setOrientation('');
                  setPage(1);
                }}
                disabled={loading}
                className="btn-lg shadow-sm"
                style={{ borderRadius: '12px' }}
                title="مسح الفلاتر"
              >
                <i className="mdi mdi-refresh text-primary"></i>
              </Button>
            </div>
          </Col>
        </Row>
      </div>
      {loading ? (
        <div className="text-center"><Spinner color="primary" /></div>
      ) : institutions.length === 0 ? (
        <div className="text-center">لا يوجد مؤسسات</div>
      ) : (
        <Row>
          {institutions.map((institution, idx) => (
            <Col md={3} className="mb-4" key={institution.id}>
              <Card style={{ boxShadow: '0 4px 16px rgba(0,0,0,0.08)', borderRadius: '18px', overflow: 'hidden', border: 'none' }}>
                <div style={{ background: '#f5f6fa', padding: '24px 0 0 0', textAlign: 'center' }}>
                  {institution.logo ? (
                    <Link to={`/dashboard/institutions/view/${institution.id}`}>
                      <img
                        src={`${FILE_BASE_URL}/uploads/images/${institution.logo}`}
                        alt={institution.title}
                        className="rounded-circle shadow"
                        style={{ width: '110px', height: '110px', objectFit: 'cover', border: '4px solid #7a6fbe', marginBottom: '-40px', background: '#fff', cursor: 'pointer' }}
                      />
                    </Link>
                  ) : (
                    <Link to={`/dashboard/institutions/view/${institution.id}`}>
                      <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white" style={{ width: '110px', height: '110px', fontSize: '38px', margin: '0 auto', border: '4px solid #7a6fbe', cursor: 'pointer' }}>
                        {institution.title?.charAt(0) || '؟'}
                      </div>
                    </Link>
                  )}
                </div>
                <CardBody style={{ paddingTop: '48px', textAlign: 'center' }}>
                  <h5 className="mb-2" style={{ color: '#7a6fbe', fontWeight: 'bold' }}>
                    <Link to={`/dashboard/institutions/view/${institution.id}`} style={{ color: '#7a6fbe', textDecoration: 'underline', cursor: 'pointer' }}>
                      {institution.title}
                    </Link>
                  </h5>
                  <div style={{ color: '#555', fontSize: '15px', marginBottom: '8px' }}>
                    <i className="mdi mdi-map-marker text-primary me-1"></i>
                    {institution.city_or_area || '-'} - {institution.country_province || '-'}
                  </div>
                  <div style={{ color: '#555', fontSize: '15px', marginBottom: '8px' }}>
                    <i className="mdi mdi-phone text-success me-1"></i>
                    {institution.phone1 || institution.mobile1 || '-'}
                  </div>
                  <div className="d-flex justify-content-center gap-2 mt-3">
                    <Link to={`/dashboard/institutions/view/${institution.id}`}>
                      <Button color="success" size="sm" style={{ minWidth: '80px' }}>عرض</Button>
                    </Link>
                    {(userRole.toLowerCase() === 'admin' || userRole.toLowerCase() === 'data_entry') && (
                      <Link to={`/dashboard/institutions/edit/${institution.id}`}>
                        <Button color="warning" size="sm" style={{ minWidth: '80px' }}>تحرير</Button>
                      </Link>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      )}
      <div className="d-flex justify-content-center mt-4">
        <Pagination>
          {[...Array(totalPages)].map((_, i) => (
            <PaginationItem active={page === i + 1} key={i}>
              <PaginationLink onClick={() => setPage(i + 1)}>{i + 1}</PaginationLink>
            </PaginationItem>
          ))}
        </Pagination>
      </div>
    </div>
  );
};

export default InstitutionsCards;
